module.exports = __webpack_public_path__ + "static/media/rcs-pge-nav.3648863b.png";